import Link from 'next/link';
import {
  ProductFilled,
  PrintTshirtFilled,
  AdvertisingMegaphoneFilled,
  WebsiteBuildAiFilled,
  SocialAnalysisMenuIcon,
  ContentStudioFilled,
  MaginWandFilled,
  PietraAiFilled,
  FactoredQualityIcon,
} from 'src/components/Common/Icons';
import './index.less';

interface IProps {
  closeActiveMenu: () => void;
}

const EcommerceSuite = ({ closeActiveMenu }: IProps) => {
  return (
    <div className="e-commerce-suite-menu-container" onClick={closeActiveMenu}>
      <div className="e-commerce-suite-menu-content">
        <div className="e-commerce-suite-menus-container">
          <div className="e-commerce-suite-menus-group">
            <div className="e-commerce-suite-menus-group-body">
              <div className="e-commerce-suite-menus pietra-ai bordered">
                <span className="title">Pietra AI</span>
                <ul>
                  <li>
                    <Link href={'/platform/pietra-ai'}>
                      <PietraAiFilled />
                      <span className="title">Pietra AI</span>
                      <span className="description">The first e-commerce AI</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="e-commerce-suite-menus-group">
            <div className="e-commerce-suite-menus-group-body">
              <div className="e-commerce-suite-menus sourcing bordered">
                <span className="title">Supply Chain</span>
                <ul>
                  <li>
                    <Link href={'/platform/sourcing-and-production/products'}>
                      <ProductFilled />
                      <span className="title">Sourcing Network</span>
                      <span className="description">Discover and manage factories</span>
                    </Link>
                  </li>
                  <li>
                    <Link href={'/platform/print-on-demand'}>
                      <PrintTshirtFilled />
                      <span className="title">Print on Demand</span>
                      <span className="description">Made-to-order merchandise</span>
                    </Link>
                  </li>
                  <li>
                    <Link href={'/platform/design-studio'}>
                      <MaginWandFilled />
                      <span className="title">Design Studio</span>
                      <span className="description">Design & visualize products</span>
                    </Link>
                  </li>
                  <li>
                    <Link href={'/platform/sourcing-and-production/products'}>
                      <FactoredQualityIcon style={{ lineHeight: '30px' }} />
                      <span className="title">Factored Quality</span>
                      <span className="description">Quality control management</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="e-commerce-suite-menus-group">
            <div className="e-commerce-suite-menus-group-body">
              <div className="e-commerce-suite-menus grow">
                <span className="title">Sales & Marketing</span>
                <ul>
                  <li>
                    <Link href={'/platform/content-studio'}>
                      <ContentStudioFilled />
                      <span className="title">Content Studio</span>
                      <span className="description">Create e-commerce marketing assets</span>
                    </Link>
                  </li>
                  <li>
                    <Link href={'/platform/social-analysis'}>
                      <SocialAnalysisMenuIcon />
                      <span className="title">Pietra Pulse</span>
                      <span className="description">Real-time social insights for your brand</span>
                    </Link>
                  </li>
                  <li>
                    <Link href={'/platform/affiliate-marketing'}>
                      <AdvertisingMegaphoneFilled />
                      <span className="title">Affiliate Management</span>
                      <span className="description">Manage commissions & payouts</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EcommerceSuite;
